const styles = {
  subMenu: {
    boxShadow: 'none !important',
    color: '#fff !important',
    fontSize: '.9375em !important',
    border: 'none !important',
    borderRadius: '0 !important',
    backgroundColor: 'transparent !important',
    marginLeft: 'auto !important',
    height: '5em !important',
    marginTop: '0 !important',
    paddingTop: '0 !important',
  },
  dropDown: {
    backgroundColor: 'transparent !important',
    border: 'none !important',
    borderRadius: '0 !important',
    color: '#4a4a4a !important',
    padding: '.75em 1.14285714em !important',
    '&:before': {
      backgroundColor: 'transparent !important',
      width: '0',
    },
  },
  dropDownMenu: {
    top: '5.125em !important',
  },
  logoutBtn: {
    border: 'none',
    outline: 'none',
    padding: '.25em',
    margin: '0',
    textAlign: 'left',
    width: '100%',
  },
};

export default styles;
